import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { ContentTypeSettingKeys } from '../../../data/interfaces';
let template = require('./content-nav-widget.html');

class ContentNavWidgetComponent extends ComponentRegistration {

    constructor() {
        super('contentNavWidget', {
            controller: ContentNavWidgetController,
            templateUrl: template,
            controllerAs: 'vm',
            bindings: {
            }
        });
    }
}

interface IContentNavWidgetController {

}

class ContentNavWidgetController implements IContentNavWidgetController {
    private static $inject: Array<string> = [];
    private ContentTypeSettingKeys = ContentTypeSettingKeys;
    constructor() {
    }

    public $onInit(): void {
    }
   
}

let contentNavWidgetComponent = new ContentNavWidgetComponent();
export default contentNavWidgetComponent;
export { contentNavWidgetComponent as ContentNavWidgetComponent, IContentNavWidgetController, ContentNavWidgetController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/setup/content-nav-widget.ts